var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMovilidad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 528.22 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f4d934;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MOVILIDAD"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 406.38,
    width: 121.83,
    height: 512
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 203.19,
    width: 121.83,
    height: 512
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 121.83,
    height: 512
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMovilidad);
export default __webpack_public_path__ + "static/media/MOVILIDAD.d331e99d42bd2272b291679e0ddf5ce1.svg";
export { ForwardRef as ReactComponent };